export default "__VITE_ASSET__BN2Q9N1___"